import { AlertBanner } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";

import {
  selectShouldShowGetNewBinButton,
  selectShouldShowMaxQtyWarningBanner,
  selectIsPreviousBinFlow,
  selectIsProductTooLargeForAllBins
} from "./autostorePutaway.slice";

const PreviousBinBanner = () => {
  const { t } = useTranslation();
  return (
    <AlertBanner severity="warning">
      {t("previous bin")}
      <br />
      {t("editing fields is not permitted")}
    </AlertBanner>
  );
};

const GetNewBinBanner = () => {
  const { t } = useTranslation();
  return (
    <AlertBanner severity="error">{t("get new bin error message")}</AlertBanner>
  );
};

const MaxQtyWarningBanner = ({
  maxFillQuantity
}: {
  maxFillQuantity: number | undefined;
}) => {
  const { t } = useTranslation();
  return (
    <AlertBanner severity="warning">
      {t("max quantity exceeded warning", {
        quantity: maxFillQuantity || "unknown"
      })}
    </AlertBanner>
  );
};

const ProductTooLargeForAllBinsBanner = () => {
  const { t } = useTranslation();
  return (
    <AlertBanner severity="error">
      {t("product too large for all bins banner")}
    </AlertBanner>
  );
};

export const Banners = ({
  maxFillQuantity
}: {
  maxFillQuantity: number | undefined;
}) => {
  const isPreviousBinFlow = useAppSelector(selectIsPreviousBinFlow);
  const shouldShowGetNewBinButton = useAppSelector(
    selectShouldShowGetNewBinButton
  );
  const shouldShowMaxQtyWarningBanner = useAppSelector(
    selectShouldShowMaxQtyWarningBanner
  );
  const isProductTooLargeForAllBins = useAppSelector(
    selectIsProductTooLargeForAllBins
  );

  if (isPreviousBinFlow) {
    return <PreviousBinBanner />;
  }

  if (isProductTooLargeForAllBins) {
    return <ProductTooLargeForAllBinsBanner />;
  }

  if (shouldShowGetNewBinButton) {
    return <GetNewBinBanner />;
  }

  if (shouldShowMaxQtyWarningBanner) {
    return <MaxQtyWarningBanner maxFillQuantity={maxFillQuantity} />;
  }

  return null;
};
